import ApiHttp from '../http';

class LoyaltyCardService {
    /**
     * Service for validating loyalty cards
     */
    constructor() {
        this.cardResult = undefined;
        this.ticketTypes = undefined;
    }

    validateCard(cinema_id, session_id, card) {


        if(card.type != 'voucher') {
            return ApiHttp.post('/cards/validate', {
                        SessionId: session_id,
                        CinemaId: cinema_id,
                        TicketTypeCode: card.type,
                        MemberCard: card.number,
                        Qty: 1
                    }
                ).then(
                    (result) => (this.cardResult = result),
                    (error) => (this.cardResult = undefined)
                );
        } else {
            return {success: true, data: [{CardNumber: card.number, TicketTypeCode: card.type, error: undefined, name: "Voucher", ApprovedQty: 1, MemberProviderName: "Voucher"}]}
        }
    }

    _parseResult(result) {
    }

    fetchTicketTypes(cinema_id, session_id) {
        return this.ticketTypes = this.ticketTypes || ApiHttp.get("/cards/ticket-types/" + cinema_id + "/" + session_id).then((result) =>(this.ticketTypes = result),
            (error) => {
                this.ticketTypes = undefined;
                return Promise.reject(error);
            })
    }

    activateVitalityCard(dateOfBirth, accountNumber, gender, name) {
        return this.activateCard = ApiHttp.post("/cards/activate/vitality", {dateOfBirth: dateOfBirth, accountNumber: accountNumber, gender: gender, initial: name}).then((result) => (this.activateCard = result),
            (error) => {
                this.activateCard = undefined;
                return Promise.reject(error);
            });
    }
}

export default new LoyaltyCardService();


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/loyalty-card-service.js